import React from 'react';
import './HeroSection.scss';

const HeroSection = (props) => (
    <section className="hero">
        <img className="hero" alt="slider_image" src={props.image} />
        {props.title ? <h1>{props.title}</h1> : null}
    </section>
);

export default HeroSection;